<template>
  <div
    :class="'span shadow list-object' + (
      homepage ? ' list-object-homepage' : ''
      )"
  >
    <div class="list-img-btn list-favorite-toggle-btn"
      :style="listFavoriteToggleBtnStyle"
      @click.stop="toggleFavorite(object)"
    >
      <i
        :class="isFavorite(object) ? 'fa fa-heart' : 'far fa-heart'"
      ></i>
    </div>
    <div
      v-if="$vuetify.breakpoint.smAndUp"
      class="list-img-btn list-img-nav-btn"
      :style="listImgRightBtnStyle"
      @click.stop="nextObjectListImg()"
    >
      <i class="fa fa-chevron-right" />
    </div>
    <div
      v-if="$vuetify.breakpoint.smAndUp"
      class="list-img-btn list-img-nav-btn"
      style="left: 10px; padding: 2px 4px 0px 9px;"
      @click.stop="prevObjectListImg()"
    >
      <i class="fa fa-chevron-left" />
    </div>
    <router-link
      :to="objectLink(object)"
    >
      <div
        v-if="object.objectImages && object.objectImages[imageIndex]"
        :class="'noselect list-object-img ' + (!showMobile ? '' : 'list-object-img-mobile')"
        :style="homepage ? 'background-image: url(\'' + 'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/objectImages/preview/' + object.objectImages[imageIndex].image + '\');' : ''"

        v-touch="{
          left: () => nextObjectListImg(),
          right: () => prevObjectListImg()
        }"
      >
        <div
          v-if="$vuetify.breakpoint.xsOnly && !hideImgBullets"
          class="compact-bullets bullets-in-list"
        >
          <i class="fas fa-circle" style="font-size: 0.6em;"></i>
          <i class="fas fa-circle" style="font-size: 0.8em;"></i>
          <i class="fas fa-circle"></i>
          <i class="fas fa-circle" style="font-size: 0.8em;"></i>
          <i class="fas fa-circle" style="font-size: 0.6em;"></i>
        </div>
        <img
          v-if="!homepage"
          :src="'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/objectImages/preview/' + object.objectImages[imageIndex].image"
          :width="!showMobile ? 273 : ''"
          :height="!showMobile ? 188 : ''"
        >
        <div class="list-preloaded-image">
          <img
            :src="'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/objectImages/preview/' + object.objectImages[imagePreloadIndex].image"
          >
        </div>
      </div>
    </router-link>
    <div
      :class="'list-object-descr ' + (!showMobile ? '' : 'list-object-descr-mobile') +
        (homepage ? '' : ' homepage')"
    >
      <v-layout wrap class="ist-object-descr-layout">
        <v-flex xs12>
        </v-flex>
        <v-flex xs7 class="list-object-name">
          <h2>{{ object.objectName }}</h2>
        </v-flex>
        <v-flex xs5 text-xs-right style="padding-right: 15px;">
          {{ $i18n.t('csr_id') }}: {{ object.csrId }}
        </v-flex>
        <v-flex xs12
          :class="'list-address ' + (
            homepage ? 'pb-2' : 'pb-1'
            )"
        >
          <h2>{{ object.address }}</h2>
        </v-flex>
        <v-flex
          :xs6="!homepage && !showMobile"
          :xs12="homepage || showMobile"
        >
          <v-layout wrap style="white-space: nowrap;
            text-overflow: ellipsis;">
            <v-flex xs12>
              <v-icon small style="width: 30px;">
                fa-home
              </v-icon>
              {{ objectTypeComputed }}
            </v-flex>
            <v-flex xs12>
              <v-icon small style="width: 30px;">
                fa-user
              </v-icon>
              {{ capitalize($i18n.t('max')) }} {{ object.maxPeople }} {{ $i18n.t('inimest') }}
            </v-flex>
            <v-flex xs12>
              <v-icon small style="width: 30px;">
                fa-bed
              </v-icon>
              {{ object.bedrooms }} {{ object.bedrooms > 1 ? $i18n.t('magamistoaga') : $i18n.t('magamistuba') }}
            </v-flex>
            <v-flex xs12>
              <v-icon small style="width: 30px;">
                fa-bath
              </v-icon>
              {{ object.bathrooms }} {{ object.bathrooms > 1 ? $i18n.t('vannitoaga') : $i18n.t('vannituba') }}
            </v-flex>
            <v-flex xs12 v-if="swmimmingPoolFeature">
              <v-icon small style="width: 30px;">
                {{ swmimmingPoolFeature && swmimmingPoolFeature.icon }}
              </v-icon>
              {{ swmimmingPoolFeature && swmimmingPoolFeature['name_' + lang] }}
            </v-flex>
            <v-flex xs12 v-else>
              <v-icon small style="width: 30px;">
                {{ parkingFeature && parkingFeature.icon }}
              </v-icon>
              {{ parkingFeature && parkingFeature['name_' + lang] }}
            </v-flex>
            <v-flex xs12>
              <v-icon v-for="(icon, iconIndex) in featuresInListIcons"
                :key="iconIndex"
                small
                style="padding: 3px 8px 2px 2px; overflow: auto;"
                v-tooltip.bottom-start="$vuetify.breakpoint.smAndUp ? icon && icon['name_' + lang] : ''"
              >
                {{ icon.icon }}
              </v-icon>
            </v-flex>
          </v-layout>

        </v-flex>
        <v-flex
          v-if="!homepage && !showMobile"
          xs6
        >
          <v-layout wrap v-if="!emailing" align-end fill-height>
            <v-flex xs12>
              <div
                v-if="!hidePrice"
                style="text-align:right; padding: 5px 15px; overflow: auto;"
              >
                <object-price v-if="!emailing" :object="object" />
              </div>
              <div
                class="list-object-button"
              >
                <router-link :to="objectLink(object)">
                  <input
                    type="button"
                    :value="$t('vaata')"
                    style="margin-right: 10px;"
                  >
                </router-link>
                <input
                  v-if="!homepage && !bookingNow"
                  type="button"
                  :value="$t('broneeri_kohe')"
                  @click="selectAndShowBookingForm(object)"
                >
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          v-if="homepage || showMobile"
          xs4
          pt-3
        >
          <router-link :to="objectLink(object)">
            <input
              type="button"
              :value="$t('vaata')"
              style="margin-right: 10px;"
            >
          </router-link>
        </v-flex>
        <v-flex
          v-if="homepage || showMobile"
          xs8
          pt-3
          style="text-align:right;padding: 0 10px; position: relative;"
        >
          <div style="position: absolute; bottom: 0; right: 0;">
            <object-price v-if="!emailing" :object="object" />
          </div>
        </v-flex>

      </v-layout>
    </div>
  </div>
</template>

<script>
import sharedMethods from './../methods/sharedMethods'
import methods from './../methods'
import ObjectPrice from './ObjectPrice'
import { createHelpers } from 'vuex-map-fields'
import state from './../state.js'
const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField'
})

export default {
  name: 'ObjectsListInfo',

  data () {
    return {
      imageIndex: 0,
      imagePreloadIndex: 1,
      hideImgBullets: false
    }
  },

  props: {
    object: {
      type: Object,
      default: () => {
        return {}
      }
    },
    bookingNow: {
      type: Boolean,
      default: false
    },
    emailing: {
      type: Boolean,
      default: false
    },
    hidePrice: {
      type: Boolean,
      default: false
    }
  },

  components: {
    ObjectPrice
  },

  computed: {
    ...mapFields(Object.keys(state)),

    listFavoriteToggleBtnStyle () {
      let style = {}
      if (this.isHomepage || !this.$vuetify.breakpoint.smAndUp) {
        style.right = '10px'
      } else {
        style.left= '231px'
      }
      if (this.isFavorite(this.object)) {
        style.color = 'red'
      } else {
        style.color = '#666'
      }
      return style
    },

    listImgRightBtnStyle () {
      let style = {
        padding: '2px 4px 0 10px'
      }
      if (this.isHomepage || !this.$vuetify.breakpoint.smAndUp) {
        style.right = '10px'
      } else {
        style.left= '231px'
      }
      return style
    },

    objectTypeComputed () {
      return this.capitalize(this.object.exactType && this.object.exactType['typeName_' +  this.lang] ||
        this.object.type['typeName_' +  this.lang])
    },

    swmimmingPoolFeature () {
      let swimmingFeatures = Object.keys(this.featuresList).filter(id => {
        return this.featuresList[id] && this.featuresList[id].code && this.featuresList[id].code.includes('wimming') && this.object.features &&
          this.object.features[id] && this.object.features[id].checked
      }).map(id => {
        return this.featuresList[id]
      })
      return swimmingFeatures[0]
    },

    parkingFeature () {
      let parkingFeatures = Object.keys(this.featuresList).filter(id => {
        return this.featuresList[id] && this.featuresList[id].code && this.featuresList[id].code.includes('parking') && this.object.features &&
          this.object.features[id] && this.object.features[id].checked
      }).map(id => {
        return this.featuresList[id]
      })
      return parkingFeatures[0]
    },

    featuresInListIcons () {
      return Object.keys(this.featuresList).filter(id => {
        const feature = this.featuresList[id]
        const isParkingFeature = feature && feature.code && feature.code.includes('parking')
        return feature && (!isParkingFeature || this.swmimmingPoolFeature) &&
          feature.showIconInList && this.object.features &&
          this.object.features[id] && this.object.features[id].checked
      }).map(id => {
        return this.featuresList[id]
      })
    },

    kitchenInfo () {
      return this.object['name_' + this.lang]
    },

    showMobile () {
      return this.homepage || !this.$vuetify.breakpoint.smAndUp
    },

    homepage () {
      return this.$route.name === 'homewlang' || this.$route.name === 'home' || !this.$vuetify.breakpoint.smAndUp
    },

    objectInfoShort () {
      return methods.replaceVars(this.object.propertiesShort, this.templateVarsByLang[this.lang])
    },

    innerWidth () {
      return window.innerWidth
    }
  },

  methods: {
    ...sharedMethods,

    hideBulletsForAMoment () {
      this.hideImgBullets = true
      setTimeout(() => {
        this.hideImgBullets = false
      }, 150)
    },

    nextObjectListImg () {
      this.hideBulletsForAMoment()
      this.imageIndex++
      if (this.imageIndex > this.object.objectImages.length - 1) {
        this.imageIndex = 0
      }
      if (this.imagePreloadIndex < this.object.objectImages.length - 1) {
        this.imagePreloadIndex++
      }
    },

    prevObjectListImg () {
      this.hideBulletsForAMoment()
      this.imageIndex--
      if (this.imageIndex < 0) {
        this.imageIndex = this.object.objectImages.length - 1
      }
    },

    selectObject (object) {
      // this.showBookNowForm = false
      // this.progressOpening = true
      // this.$router.push({ path: this.objectLink(object) })
      // window.scrollTo(0, 0)
    },

    selectAndShowBookingForm (object) {
      this.$router.push({ path: this.objectBookingLink(object) })
      window.scrollTo(0, 0)
    },
  }
}
</script>

<style>
.list-object-descr {
  float: right;
  width: calc(100% - 288px);
  padding-top: 6px;
}
.ist-object-descr-layout {
  height: 152px;
}
.list-object-descr-mobile {
  width: 100%;
  padding: 8px;
  position: relative;
}
.list-object-text {
  color: gray;
  margin: 0;
  padding-bottom: 2px;
}
.list-object-nav {
  margin-top: 0px;
}
.list-object-button {
  float: right;
  padding-right: 14px;
  padding-bottom: 6px;
}
.list-object-homepage .list-object-button {
  position: absolute;
  bottom: 15px;
  left: 15px;
  padding-bottom: 0;
}
.list-object-homepage .list-object-descr .list-object-text {
  overflow: hidden;
  max-height: 103px;
}
.list-object-homepage .list-object-nav {
  position: absolute;
  bottom: 15px;
  right: 15px;
}
.list-object-homepage .list-object-nav .list-object-price {
  font-size: 1.1em;
}
.list-object-img {
  position: relative;
  margin-right: 15px;
  float: left;
  cursor: pointer;
  height: 188px;
  background-position: 50% 50%;  /* Sets reference point to scale from */
  background-size:cover;        /* Sets background image to cover entire element */
}
.list-object-img img {
  /*position: absolute;
  top: 50%;
  left: 50%;
  width: 600px;
  height: 400px;
  margin-top: -89px;
  margin-left: -200px;*/
}
.list-object-img-mobile {
  width: 100%;
  position: relative;
  /* height: auto; */
}
.list-preloaded-image {
  position: absolute;
  left: -10000px;
  top: 0;
}
.list-object-homepage {
  width: calc(33.333% - 20px);
  float: left;
  margin-right: 20px;
  height: 430px;
}
.homepage-list-container {
  width: calc(100% + 20px);
}
@media only screen and (min-width: 960px) and (max-width: 1150px) {
  .list-object-homepage {
    height: 440px;
    margin-right: 10px;
    width: calc(50% - 10px);
  }
  .list-object-homepage .list-object-nav {
    bottom: 15px;
  }
  .homepage-list-container {
    width: calc(100% + 10px);
  }
}
@media only screen and (min-width: 960px) and (max-width: 1150px) {
  .list-object-homepage {
    height: 430px;
  }
}
@media only screen and (max-width: 959px) {
  .list-object-homepage .list-object-nav {
    bottom: 15px;
  }
  .list-object-homepage {
    height: 440px;
    width: calc(33.333% - 15px);
    margin-right: 15px;
  }
  .homepage-list-container {
    width: calc(100% + 15px);
  }
}
@media only screen and (max-width: 840px) {
  .list-object-homepage {
    height: 430px;
    width: calc(50% - 10px);
    margin-right: 10px;
  }
  .homepage-list-container {
    width: calc(100% + 10px);
  }
}
@media only screen and (max-width: 550px) {
  .list-object-homepage {
    height: 440px;
    width: 100%;
  }
  .homepage-list-container {
    width: 100%;
  }
  .list-object-img {
    height: 200px;
  }
  .list-object-homepage .list-object-nav {
    bottom: 20px;
  }
}
.list-address h2 {
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-address_x {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list-address_x h2 {
  text-overflow: ellipsis;
}
.list-object-name h2 {
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 15px;
  color: #219bc8;
  /*color: #ffcb01;*/
}
.bullets-in-list {
  top: 178px;
  opacity: 0.9
}
.list-favorite-toggle-btn {
  top: 10px;
}
.list-img-btn {
  cursor: pointer;
  opacity: 0.75;
  border-radius: 100px;
  padding: 3px 4px 0 6px;
  font-size: 18px;
  background: white;
  width: 30px;
  height: 30px;
  z-index: 1;
  position: absolute;
}
.list-img-nav-btn {
  display: none;
  top: 79px;
}
.list-object:hover .list-img-nav-btn {
    display: block;
}
</style>
